import { render, staticRenderFns } from "./RecentUserList.vue?vue&type=template&id=a668d874&scoped=true"
import script from "./RecentUserList.vue?vue&type=script&lang=js"
export * from "./RecentUserList.vue?vue&type=script&lang=js"
import style0 from "./RecentUserList.vue?vue&type=style&index=0&id=a668d874&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a668d874",
  null
  
)

export default component.exports